module.exports = __webpack_public_path__ + "static/media/warn-archived.200953a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/warn-archived.svg
// module id = 1241
// module chunks = 0